import axios from 'axios'
import ElementUI from 'element-ui';
import { message } from './message';
import router from '@/router'
// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL_FW,
    // baseURL: 'http://192.168.9.47/bhfw_v2/public',
    // baseURL: '/xiao/bhfw/public/index.php',
    // baseURL: 'https://wq.tjbinhang.cn',
    // baseURL: 'http://192.168.9.59:8090',
    // baseURL: 'https://new.testbhfw.lianghang.cc',
    timeout: 600000, // 请求超时时间
    withCredentials: true,
    data: {}
    // crossDomain: true
})

// request拦截器
service.interceptors.request.use(
    config => {
        let token = localStorage.getItem('FW_TOKEN')
        // let x_token = localStorage.getItem('x_token')
        let tmp = localStorage.getItem('token')
        // let platform = localStorage.getItem('platform')
        // if(platform){
        //     config.headers['abc'] = platform
        // }
        // if(!token){
        config.headers['Authorization'] = tmp
        // }
        // else{
        //     config.headers['Authorization'] = token // 让每个请求携带自定义token 请根据实际情况自行修改
        //     // config.headers['X-CSRF-TOKEN'] = x_token
        // }
        var lang = localStorage.getItem('lang')//因为项目中使用到了i18n国际化语言配置，请根据实际情况自行修改
        if (!lang) {
            lang = 'zh_CN'
        }
        // config.headers['Accept-Language'] = lang.replace(/_/g, '-')
        // config.headers['Content-Type'] = 'application/json'
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response 拦截器
service.interceptors.response.use(
    response => {
        if (response.data.code === 401) {
            //  store.dispatch('LogOut').then(() => {
            //      // 用户登录界面提示
            //      Cookies.set('point', 401)
            //      location.reload()
            // })
        } else if (response.data.code === 303) {
            console.log(111)
            message({
                message:'登录超时，请重新登录！',
                type:'error'
            })
            setTimeout(()=>{
                router.push({ path: '/login' })
            },3000)
        }
        return response.data
    },
    error => {
        let code = 0
        try {
            code = error.response.data.status
        } catch (e) {
            if (error.toString().indexOf('Error: timeout') !== -1) {
                console.log(1,1)
                return Promise.reject(error)
            }
        }
        if (code) {
            if (code === 401) {
                //  store.dispatch('LogOut').then(() => {
                //      // 用户登录界面提示
                //      Cookies.set('point', 401)
                //      location.reload()
                // })
            } else if (code === 303) {
                console.log(111)
                message({
                    message:'登录超时，请重新登录！',
                    type:'error'
                })
                setTimeout(()=>{
                    let password = localStorage.getItem('password')
                    let phone = localStorage.getItem('phone')
                    localStorage.clear()
                    localStorage.setItem('password',password)
                    localStorage.setItem('phone',phone)
                    router.push({ path: '/login' })
                },3000)
                return
            } else {
                const errorMsg = error.response.data.message
                if (errorMsg !== undefined) {
                    // Notification.error({
                    //     title: errorMsg,
                    //     duration: 0
                    // })
                }
            }
        } else {
            message({
                message: error.message ? error.message : "接口请求失败",
                type: 'error'
            })
        }
        return Promise.reject(error)
    }
)
export default service
